import styled from '@emotion/styled';
import { MEDIA_QUERIES, SPACER } from 'radiance-ui/lib/constants';

export const GlyphsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  max-width: 100%;
  overflow-x: auto;
  scroll-behavior: smooth;
  margin-bottom: 1.5rem;

  & > div:not(:last-of-type) {
    margin-right: ${SPACER.medium};
  }

  ${MEDIA_QUERIES.smUp} {
    & > div:not(:last-of-type) {
      margin-right: ${SPACER.xlarge};
    }
  }

  ${MEDIA_QUERIES.xlUp} {
    padding: 0 ${SPACER.medium};
  }
`;
